import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {listClasses} from '../utils/utilsDataSpec';

import * as PD from '../classes/pdStyle';

class ListClasses extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Classes: [],
            errorMessage: ''
        };

        this.dsd = new dsd();
    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){
   if (!isEqual(this.props, prevProps)){
       this.setup();
   }
}

loadData(filters){

    const onLoad = function(arr){
        this.setState({ Classes: arr, renderState: 'loaded' });
        if (this.state.onLoad){ this.state.onLoad(arr.length); }
    }.bind(this);

    const onError = function(e){
        this.setState({ renderState: 'failed', errorMessage: e.message });
    }.bind(this);

    listClasses(this.dsd, filters, onLoad, onError);
}

setup(){

    let StateChange = {
        filters: {},
        columns: {
            owner:false,
            dataspec: false
        },
        onLoad: null
    }

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);
    this.loadData(StateChange.filters);
        
}



    included(Class) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {

        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    {this.state.errorMessage || 'A problem has occurred'}
                </PD.ErrorBox>
            )
        }

        if (this.state.renderState === 'loaded') {
            let arrClasses = this.state.Classes;
            if (isArray(arrClasses)){
                if (arrClasses.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.dataspec &&
                                        <PD.Th>Data Spec</PD.Th>                            
                                    }

                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrClasses.map(
                                    (Class, pos) => 
                                    {
                                        if (this.included(Class)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/class/" + Class._id} > {Class.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Class.DataSpec){
                                                                        if (Class.DataSpec.Owner){
                                                                            return Class.DataSpec.Owner.organisation;
                                                                        }
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.dataspec &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Class.DataSpec){
                                                                        return Class.DataSpec.name;
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Class.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListClasses_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListClasses {...props} navigation={navigation} location={location} params={params} />;
}